module.exports = __webpack_public_path__ + "media/components/src/assets/images/what_day/crown2-39ad590816407e9bcc764d7bd5543cc3.png";